import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    fr: {
        translation: {
            connexion: {
                login: "Connexion",
                signIn: "Se connecter",
                loginGoogle: "Connexion Google",
                loginFacebook: "Connexion Facebook",
                loginTwitter: "Connexion Twitter",
                loginEmailPassword: "Connexion Email / Mot de passe",
                loginPhone: "Connexion par téléphone",

                loginSuccess: "Connexion réussie.",
                loginGoogleSuccess: "Connexion Google réussie.",
                loginFacebookSuccess: "Connexion Facebook réussie.",
                loginTwitterSuccess: "Connexion Twitter réussie.",
                loginEmailPasswordSuccess: "Connexion Email / Mot de passe réussie.",
                loginPhoneSuccess: "Connexion téléphone réussie.",

                loginError: "Connexion impossible.",
                loginGoogleError: "Connexion Google impossible.",
                loginFacebookError: "Connexion Facebook impossible.",
                loginTwitterError: "Connexion Twitter impossible.",
                loginEmailPasswordError: "Connexion Email / Mot de passe impossible.",
                loginPhoneError: "Connexion téléphone impossible.",

                loginInProgress: "Connexion en cours…",

                forgotPassword: "Mot de passe oublié ?",
                orContinueWith: "ou continuer avec",
                continueWithGoogle: "Continuer avec Google",

                noAccount: "Pas encore de compte ?",
                createAccount: "Créer un compte",
                emailNotVerified: "Votre adresse email n'est pas encore vérifiée. Consultez votre boîte mail.",
                userNotFound: "Utilisateur introuvable.",
                incorrectPassword: "Mot de passe incorrect.",
                invalidEmailOrPassword: "Email ou mot de passe invalide.",
                invalidEmail: "Adresse email invalide.",

                signUp: "S'inscrire",
                alreadyHaveAccount: "Déjà un compte ?",
                emailAlreadyInUse: "Cette adresse email est déjà utilisée.",
                passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères.",
                firebaseConnectionError: "Impossible de contacter Firebase.",
                unknownError: "Erreur inconnue.",
            },
            common: {
                code: "Code",
                id: "Identifiant",
                and: "et",
                or: "ou",
                yes: "Oui",
                no: "Non",
                select: "Sélectionner...",
                noOptions: "Aucune option disponible",
                loading: "Chargement...",
                attachments: "Pièces jointes",
                attachment: "Pièce jointe",
                chooseFile: "Choisir un fichier",
                noAttachment: "Aucune pièce jointe",
                allowedFormats: "Formats autorisés : ",
                maxSize: "Taille maximale : ",
                loadListsError: "Impossible de charger les listes.",
                deleteError: "Impossible de supprimer.",
                validationErrors: "Erreurs de validation",
                french: "En français",
                arabic: "En arabe",
                english: "En anglais",
                actions: "Actions",
                rows: "Lignes",
                welcome: "Bienvenue sur FelahLink",
                welcomeDescription: "Mettre rapidement en relation les agriculteurs avec les consultants agricoles, vétérinaires et experts du secteur agricole les plus proches.",
                contact: "Contact",
                navigation: "Navigation",

                felahLink: "FelahLink",
                location: "Alger - Algérie",
                about: "À propos",
                version: "Version v1.0",
                platformDescription: "Plateforme nationale de mise en relation entre les agriculteurs, les consultants agricoles, les vétérinaires et les experts du secteur agricole.",
                services: "Services",
                consultantSearch: "Recherche de consultants",
                onlineConsultation: "Consultation en ligne",
                farmManagement: "Gestion des exploitations",
                technicalAssistance: "Assistance technique",
                deleteSuccess: "Enregistrement supprimé avec succès !",

            },
            validation: {
                requiredMessage: "Le message est obligatoire.",
                consultationObjectRequired: "L'objet de la consultation est obligatoire.",
                receiverRequired: "Veuillez sélectionner un consultant.",
                activityTypeRequired: "Le type d'activité est obligatoire",
                activityProfRequired: "L'activité en français est obligatoire",
                correctErrors: "Veuillez corriger les erreurs",
                updateError: "Erreur lors de la mise à jour.",
                validationErrors: "Erreurs de validation.",

            },
            menu: {
                mainMenu: "Menu principal",
                dashboard: "Tableau de bord",
                adminPanel: "Panneau d'administration",

                home: "Accueil",
                file: "Fichier",

                activityProf: "Activité professionnelle",
                activityType: "Type d'activité",
                consultantStatus: "Statut consultant",
                speciality: "Spécialité",
                wilaya: "Wilaya",
                commune: "Commune",

                user: "Utilisateur",
                roleUser: "Rôles des utilisateurs",
                consultant: "Consultant",
                consultation: "Consultation",
                forum: "Forum",

                profile: "Mon profil",
                account: "Mon compte",
                settings: "Paramètres",
                language: "Langue",
                logout: "Déconnexion",
            },
            navbar: {
                notifications: "Notifications",
                messages: "Messages"
            },
            button: {
                search: "Rechercher",
                reset: "Réinitialiser",
                save: "Enregistrer",
                cancel: "Annuler",
                back: "Retour",
                profile: "Voir le profil",
                consultation: "Consultation",
                available: "Disponible",
                verified: "Vérifié",
                detail: "Voir les détails",
                actions: "Actions",
                details: "Détails",
                view: "Voir",
                add: "Ajouter",
                edit: "Modifier",
                delete: "Supprimer",
                create: "Nouvelle demande",
                send: "Envoyer",
                reply: "Répondre",
                close: "Clôturer",
                reopen: "Rouvrir",
                close: "Fermer",
                deleteConfirmationTitle: "Confirmation de suppression",
                deleteConfirmationMessage: "Êtes-vous sûr de vouloir supprimer cet enregistrement ?",
                download: "Télécharger",

            },

            profile: {
                saveSuccess: "Profil enregistré avec succès !",
                updateSuccess: "Profil mis à jour avec succès.",
                new: "Nouveau profil",
                edit: "Modifier le profil",
                french: "Profil en français",
                arabic: "Profil en arabe",
                english: "Profil en anglais",
                loadError: "Erreur lors du chargement du profil.",
                deleteError: "Impossible de supprimer le profil.",
                addSuccess: "Profil ajouté avec succès.",
                addError: "Impossible d'ajouter le profil.",
                deleteSuccess: "Profil supprimé avec succès."
            },

            specialite: {
                titre: "Spécialité",
                saveSuccess: "Spécialité enregistrée avec succès !",
                new: "Nouvelle spécialité",
                edit: "Modifier une spécialité",
                french: "Spécialité en français",
                arabic: "Spécialité en arabe",
                english: "Spécialité en anglais",
                loadError: "Erreur lors du chargement de la spécialité :",
                deleteError: "Impossible de supprimer la spécialité.",
                addSuccess: "Spécialité ajoutée.",
                editSuccess: "Spécialité modifiée avec succès.",
                addError: "Impossible d'ajouter la spécialité.",
                deleteSuccess: "Spécialité supprimée.",
                list: "Liste des spécialités",

            },


            utilisateur: {

                titre: "Utilisateur",
                list: "Liste des utilisateurs",
                listDescription: "Gestion des utilisateurs de la plateforme",

                new: "Nouvel utilisateur",
                edit: "Modifier l'utilisateur",

                fullName: "Nom complet",
                email: "Email",
                phoneNumber: "Téléphone",
                type: "Type",

                typeFelah: "Fellah",
                typeProf: "Professionnel",
                typeFournisseur: "Fournisseur",
                unknownType: "Inconnu",

                french: "Utilisateur en français",
                arabic: "Utilisateur en arabe",
                english: "Utilisateur en anglais",

                noUsers: "Aucun utilisateur trouvé.",
                loading: "Chargement des utilisateurs...",
                loadingError: "Impossible de charger les utilisateurs.",
                loadError: "Erreur lors du chargement de l'utilisateur.",

                addSuccess: "Utilisateur ajouté avec succès.",
                saveSuccess: "Utilisateur enregistré avec succès.",
                editSuccess: "Utilisateur modifié avec succès.",
                deleteSuccess: "Utilisateur supprimé avec succès.",

                addError: "Impossible d'ajouter l'utilisateur.",
                saveError: "Impossible d'enregistrer l'utilisateur.",
                updateError: "Impossible de modifier l'utilisateur.",
                deleteError: "Impossible de supprimer l'utilisateur.",

                page: "Page",
                enabled: "Activé",

                roles: "Rôles",
                role: "Rôle",

                roleAddSuccess: "Rôle ajouté avec succès.",
                roleRemoveSuccess: "Rôle supprimé avec succès.",

                roleAddError: "Impossible d'ajouter le rôle.",
                roleRemoveError: "Impossible de supprimer le rôle.",

                rolesLoadError: "Impossible de charger les rôles.",
                roleInvalid: "Le rôle sélectionné est invalide.",
            },





            typeActivite: {
                titre: " Type d'activité ",
                saveSuccess: "Type d'activité enregistré avec succès !",
                new: "Nouveau type d'activité",
                edit: "Modifier un type d'activité",
                french: "Type d'activité en français",
                arabic: "Type d'activité en arabe",
                english: "Type d'activité en anglais",
                loadError: "Erreur lors du chargement de type d'activité :",
                deleteError: "Impossible de supprimer type d'activité.",
                addSuccess: "Type d'activité ajouté.",
                editSuccess: "Type d'activité modifiée avec succès.",
                addError: "Impossible d'ajouter type d'activité.",
                deleteSuccess: "Type d'activité supprimée.",
                list: "Liste des types d'activités",
            },

            commune: {
                titre: "Commune",
                saveSuccess: "Commune enregistrée avec succès !",
                new: "Nouvelle commune",
                edit: "Modifier une commune",
                french: "Commune en français",
                arabic: "Commune en arabe",
                english: "Commune en anglais",
                loadError: "Erreur lors du chargement de la commune :",
                deleteError: "Impossible de supprimer la commune.",
                addSuccess: "Commune ajoutée.",
                editSuccess: "Commune modifiée avec succès.",
                addError: "Impossible d'ajouter la commune.",
                deleteSuccess: "Commune supprimée.",
                list: "Liste des communes",
            },
            wilaya: {
                titre: "Wilaya",
                saveSuccess: "Wilaya enregistrée avec succès !",
                new: "Nouvelle wilaya",
                edit: "Modifier une wilaya",
                french: "Wilaya en français",
                arabic: "Wilaya en arabe",
                english: "Wilaya en anglais",
                loadError: "Erreur lors du chargement de la wilaya :",
                deleteError: "Impossible de supprimer la wilaya.",
                addSuccess: "Wilaya ajoutée.",
                editSuccess: "Wilaya modifiée avec succès.",
                addError: "Impossible d'ajouter la wilaya.",
                deleteSuccess: "Wilaya supprimée.",
                list: "Liste des wilayas",
            },

            statut: {
                titre: "Statut",
                saveSuccess: "Statut enregistré avec succès !",
                new: "Nouveau statut",
                edit: "Modifier un statut",
                french: "Statut en français",
                arabic: "Statut en arabe",
                english: "Statut en anglais",
                loadError: "Erreur lors du chargement du statut :",
                deleteError: "Impossible de supprimer le statut.",
                addSuccess: "Statut ajouté.",
                editSuccess: "Statut modifié avec succès.",
                addError: "Impossible d'ajouter le statut.",
                deleteSuccess: "Statut supprimée.",
                list: "Liste des statuts",
            },

            activiteProf: {
                titre: "Activité Professionnelle",
                saveSuccess: "Activité professionnelle enregistrée avec succès !",
                new: "Nouvelle activité professionnelle",
                edit: "Modifier une activité professionnelle",
                french: "Activité professionnelle en français",
                arabic: "Activité professionnelle en arabe",
                english: "Activité professionnelle en anglais",
                loadError: "Erreur lors du chargement de l'activité professionnelle :",
                deleteError: "Impossible de supprimer l'activité professionnelle.",
                addSuccess: "Activité professionnelle ajoutée.",
                editSuccess: "Activité professionnelle modifiée avec succès.",
                addError: "Impossible d'ajouter l'activité professionnelle.",
                deleteSuccess: "Activité professionnelle supprimée.",
                list: "Liste des activités professionnelles",
            },

            consultant: {
                search: {
                    title: "Trouver votre consultant",
                    subtitle: "Recherchez un consultant agricole, vétérinaire ou spécialiste près de chez vous.",
                    keyword: "Mot clé",
                    placeholder: "Rechercher un consultant, une spécialité, une wilaya...",
                    result: "{{count}} consultant(s) trouvé(s)",
                    select: "Sélectionner...",
                },

                types: {
                    agriculture: "Consultant en agriculture",
                    livestock: "Conseiller d'élevage"
                },

                filters: {
                    title: "Critères de recherche",
                    type: "Type de consultant",
                    activities: "Activités professionnelles",
                    specialities: "Spécialités",
                    wilaya: "Wilaya",
                    experience: "Expérience minimale",
                    available: "Disponible immédiatement",
                    choose: "Choisir...",
                    allWilayas: "Toutes les wilayas",
                    all: "Toutes",
                    experience1: "1 an",
                    experience3: "3 ans",
                    experience5: "5 ans",
                    experience10: "10 ans",
                    experience20: "20 ans et +"
                },

                card: {
                    agriculturalConsultant: "Consultant agricole",
                    livestockAdvisor: "Conseiller d'élevage",
                    verified: "Vérifié",
                    available: "Disponible",
                    yearsExperience: "{{count}} année(s) d'expérience",
                    profile: "Voir le profil",
                    consultation: "Consultation",
                    consultant: "Consultant",
                    requester: "Demandeur"
                }
            },

            consultationRequest: {

                title: "Demandes de consultation",
                subtitle: "Consultez et gérez vos demandes de consultation.",

                pageTitleReceiver: "Demandes à traiter",
                pageTitleSender: "Mes demandes de consultation",


                titleReceiver: "Demande (s) à traiter",
                titleSender: "Demande (s)",

                search: "Rechercher",
                searchPlaceholder: "Objet de la consultation...",

                noData: "Aucune demande de consultation",
                noDescription: "Aucune description",
                loading: "Chargement des demandes...",

                consultant: "Consultant",
                requester: "Demandeur",
                subject: "Sujet",
                message: "Message",
                date: "Date",
                createdOn: "Créée le {{date}}",
                status: "Statut",
                priority: "Priorité",

                confirmDelete: "Voulez-vous supprimer cette demande ?",
                statusPending: "En attente",
                statusAccepted: "Acceptée",
                statusRejected: "Refusée",
                statusInProgress: "En cours",
                statusClosed: "Clôturée",

                priorityLow: "Faible",
                priorityNormal: "Normale",
                priorityHigh: "Élevée",
                priorityUrgent: "Urgente",
                requestInfo: "Informations sur la demande",
                wishToConsult: "Je souhaite consulter",
                consultantSearch: "Recherche du consultant",

                pageTitleAll: "Toutes les consultations",
                pageTitleSender: "Consultations émises",
                pageTitleReceiver: "Consultations reçues",
            },
            messageComposer: {
                fileTooLarge: "Le fichier \"{{fileName}}\" dépasse la taille maximale autorisée ({{maxSize}}).",
                invalidExtension: "Le format \"{{extension}}\" n'est pas autorisé.",
                maxFilesReached: "Vous ne pouvez pas joindre plus de {{maxFiles}} fichiers.",
                subject: "Objet",
                message: "Votre message",
                nmessages: "message (s)",
                conversation: "Conversation",
                noContentMessage: "No content.",
            },

            forum: {
                title: "Forum des agricultures",
                home: "Accueil",
                newTopic: "Nouveau sujet",
                editTopic: "Modifier le sujet",
                deleteTopic: "Supprimer le sujet",

                guestMessage:
                    "Vous pouvez consulter le forum librement. Pour publier un sujet ou participer aux discussions, veuillez vous connecter.",
                objet: "Objet",
                searchTopic: "Rechercher un sujet",
                search: "Rechercher",
                reset: "Réinitialiser",
                searchPlaceholder: "Titre, auteur, mot-clé, culture, élevage...",

                topics: "Sujets",
                statistics: "Statistiques",
                topicDetail: "Détail du sujet",
                openDiscussion: "Ouvrir une discussion",

                views: "Vues",
                likes: "J'aime",
                replies: "Réponses",
                open: "Ouvrir",
                detail: "Détail",

                latestTopics: "Derniers sujets",
                noTopics: "Aucun sujet",
                mostViewed: "Les plus consultés",
                advice: "Conseils",
                noDescription: "Aucune description.",
                solved: "Résolu",
                pinned: "Épinglé",
                checkExistingQuestion: "Vérifiez si votre question existe déjà.",
                details: "Détails",
                reply: "Répondre",
                backToTopic: "Retour au sujet",
                openDiscussionButton: "Ouvrir la discussion",
                replyPostedBy: "Réponse publiée par : ",
                description: "Description du sujet",

                descriptionHelp: "Plus votre description est détaillée, plus les réponses seront pertinentes.",
                pinTopic: "Épingler le sujet",
                noFileChosen: "Aucun fichier choisi",
                editTopic: "Modifier le sujet",
                saving: "Enregistrement...",
                topicObjectPlaceholder: "Exemple : Comment irriguer les oliviers en été ?",
                topicDescriptionPlaceholder: "Décrivez votre question le plus précisément possible...",
                topicObjectRequired: "L'objet du sujet est obligatoire.",
                topicObjectMinLength: "L'objet doit contenir au minimum 5 caractères.",
                topicObjectMaxLength: "L'objet ne doit pas dépasser 100 caractères.",
                topicDescriptionRequired: "La description du sujet est obligatoire.",
                topicDescriptionMinLength: "La description doit contenir au minimum 10 caractères.",
                topicDescriptionMaxLength: "La description ne doit pas dépasser 3000 caractères.",
                invalidFileType: "Seuls les fichiers PDF, JPG, JPEG et PNG sont autorisés.",
                noReplies: "Aucune réponse",
                beFirstToReply: "Soyez le premier à répondre à cette discussion.",



                messageOrFileRequired: "Veuillez saisir un message ou joindre au moins un fichier.",

                ForumReply: {
                    subject: "Sujet",
                    reply: "Réponse",
                    backToSubject: "Retour au sujet",
                    publishReply: "Publier la réponse",
                    reset: "Réinitialiser",
                    enterYourReply: "Saisissez votre réponse…",
                    allowedFormats: "Les formats autorisés sont :",
                    allowedFileTypes: "PDF, JPG, JPEG, PNG, DOC, DOCX, XLS, XLSX.",
                    maximumRecommendedSize: "Taille maximale conseillée :",
                    perFile: "par fichier",
                    megabytes: "10 Mo",
                    messageOrFileRequired: "Veuillez saisir un message ou joindre au moins un fichier.",
                },
            },
            monProfile: {
                title: "Mon profil",
                header: "Informations du profil",
                personalInformation: "Informations personnelles",
                professionalInformation: "Informations professionnelles",
                farmerInformation: "Informations de l'agriculteur",
                supplierInformation: "Informations du fournisseur",

                summary: "Résumé",
                contactInformation: "Coordonnées",
                addressInformation: "Adresse",
                accountInformation: "Informations du compte",

                photo: "Photo",
                changePhoto: "Changer la photo",
                removePhoto: "Supprimer la photo",
                noPhoto: "Aucune photo",

                identity: "Identité",
                personalDetails: "Informations personnelles",
                professionalDetails: "Informations professionnelles",

                consultantInformation: "Informations du consultant",
                activityInformation: "Informations d'activité",

                saveSuccess: "Profil enregistré avec succès.",
                saveError: "Erreur lors de l'enregistrement du profil.",

                loading: "Chargement du profil...",
                saving: "Enregistrement du profil...",
                activiteStartDate: "Date début d'activité",

                profilePhoto: "Photo de profil",
                editPhoto: "Modifier la photo",
                uploading: "Téléchargement...",
                choosePhoto: "Choisir une photo",
                removePhoto: "Supprimer la photo",
                profileAlt: "Profil",
                personalInformation: "Informations personnelles",
                fullName: "Nom complet",
                email: "Adresse e-mail",
                password: "Mot de passe",
                phoneNumber: "Téléphone",
                wilaya: "Wilaya",
                commune: "Commune",
                address: "Adresse",
                userType: "Type d'utilisateur",

                farmer: "🌾 Fellah",
                professional: "👨‍🌾 Professionnel",
                supplier: "🏪 Fournisseur",

                professionalInformation: "Informations professionnelles",
                website: "Site Web",
                status: "Statut",
                activityType: "Type d'activité",
                professionalActivities: "Activités professionnelles",
                specialties: "Spécialités",

                consultantAgriculture: "Consultant en agriculture",
                livestockAdvisor: "Conseiller / Conseillère d'élevage",

                password: "Mot de passe",
                showPassword: "Afficher le mot de passe",
                hidePassword: "Masquer le mot de passe",
                passwordStrength: {
                    veryWeak: "Très faible",
                    weak: "Faible",
                    medium: "Moyen",
                    strong: "Fort",
                    veryStrong: "Très fort"
                },

                farmerInformation: "Informations agricoles",

                agriculturalActivities: "Activités agricoles",
                irrigationSystem: "Système d'irrigation",
                agriculturalInsurance: "Assurance agricole",
                yearsOfExperience: "Années d'expérience",

                activityTypes: {
                    agriculture: "Agriculture",
                    livestock: "Élevage",
                    mixed: "Mixte"
                },




            },

            statistics: {
                consultants: "Consultants",
                consultantsDescription: "Experts agricoles et conseillers d'élevage",

                felah: "Fellahs",
                felahDescription: "Agriculteurs et éleveurs enregistrés",

                agriculture: "Agriculture",
                agricultureDescription: "Fellahs en agriculture",

                elevage: "Élevage",
                elevageDescription: "Fellahs en élevage",

                specialites: "Spécialités",
                specialitesDescription: "Spécialités agricoles et d'élevage",

                activities: "Activités",
                activitiesDescription: "Activités professionnelles",

                consultations: "Consultations",
                consultationsDescription: "Demandes de consultation enregistrées",

                forum: "Forum",
                forumDescription: "Sujets de discussion",

                loading: "Chargement...",
                loadingError: "Impossible de charger les statistiques.",
            },

        },

    },

    //---------------------------------------------------------
    // ENGLISH
    //---------------------------------------------------------

    en: {
        translation: {
            connexion: {
                login: "Login",
                signIn: "Sign in",
                loginGoogle: "Google Login",
                loginFacebook: "Facebook Login",
                loginTwitter: "Twitter Login",
                loginEmailPassword: "Email / Password Login",
                loginPhone: "Phone Login",

                loginSuccess: "Login successful.",
                loginGoogleSuccess: "Google login successful.",
                loginFacebookSuccess: "Facebook login successful.",
                loginTwitterSuccess: "Twitter login successful.",
                loginEmailPasswordSuccess: "Email / Password login successful.",
                loginPhoneSuccess: "Phone login successful.",

                loginError: "Login failed.",
                loginGoogleError: "Google login failed.",
                loginFacebookError: "Facebook login failed.",
                loginTwitterError: "Twitter login failed.",
                loginEmailPasswordError: "Email / Password login failed.",
                loginPhoneError: "Phone login failed.",

                loginInProgress: "Logging in…",

                forgotPassword: "Forgot your password?",
                orContinueWith: "or continue with",
                continueWithGoogle: "Continue with Google",

                noAccount: "Don't have an account yet?",
                createAccount: "Create an account",
                emailNotVerified: "Your email address has not been verified yet. Please check your inbox.",
                userNotFound: "User not found.",
                incorrectPassword: "Incorrect password.",
                invalidEmailOrPassword: "Invalid email or password.",
                invalidEmail: "Invalid email address.",

                signUp: "Sign up",
                alreadyHaveAccount: "Already have an account?",
                emailAlreadyInUse: "This email address is already in use.",
                passwordMinLength: "The password must contain at least 6 characters.",
                firebaseConnectionError: "Unable to contact Firebase.",
                unknownError: "Unknown error.",

            },
            common: {
                code: "Code",
                id: "ID",
                and: "and",
                or: "or",
                yes: "Yes",
                no: "No",
                select: "Select...",
                noOptions: "No options available",
                loading: "Loading...",
                attachments: "Attachments",
                attachment: "Attachment",
                chooseFile: "Choose a file",
                noAttachment: "No attachment",
                allowedFormats: "Allowed formats: ",
                maxSize: "Maximum size: ",
                deleteError: "Unable to delete.",
                french: "In French",
                arabic: "In Arabic",
                english: "In English",
                actions: "Actions",
                rows: "Rows",
                welcome: "Welcome to FelahLink",
                welcomeDescription: "Quickly connect farmers with nearby agricultural consultants, veterinarians, and experts in the agricultural sector.",
                contact: "Contact",
                navigation: "Navigation",
                loadListsError: "Unable to load the lists.",
                felahLink: "FelahLink",
                location: "Algiers - Algeria",
                about: "About",
                version: "Version v1.0",
                platformDescription: "National platform connecting farmers with agricultural consultants, veterinarians, and experts in the agricultural sector.",
                services: "Services",
                consultantSearch: "Consultant Search",
                onlineConsultation: "Online Consultation",
                farmManagement: "Farm Management",
                technicalAssistance: "Technical Assistance",
                deleteSuccess: "Record deleted successfully!",


            },
            validation: {
                requiredMessage: "The message is required.",
                consultationObjectRequired: "The consultation subject is required.",
                receiverRequired: "Please select a consultant.",
                activityTypeRequired: "Activity type is required",
                activityProfRequired: "French activity is required",
                correctErrors: "Please correct the errors",
                updateError: "Error while updating.",
                validationErrors: "Validation errors",
            },

            button: {
                search: "Search",
                reset: "Reset",
                save: "Save",
                cancel: "Cancel",
                back: "Back",
                profile: "View profile",
                consultation: "Consultation",
                available: "Available",
                verified: "Verified",
                detail: "View details",

                actions: "Actions",
                details: "Details",
                add: "Add",
                view: "View",
                edit: "Edit",
                delete: "Delete",

                create: "New Request",
                send: "Send",
                reply: "Reply",
                close: "Close",
                reopen: "Reopen",
                close: "Close",
                deleteConfirmationTitle: "Delete confirmation",
                deleteConfirmationMessage: "Are you sure you want to delete this record ?",
                download: "Télécharger",

            },

            menu: {
                mainMenu: "Main Menu",
                dashboard: "Dashboard",
                adminPanel: "Administration Panel",

                home: "Home",
                file: "Master Data",
                activityProf: "Professional Activity",
                activityType: "Activity Type",
                consultantStatus: "Consultant Status",
                speciality: "Speciality",
                wilaya: "Province",
                commune: "Municipality",

                user: "Users",
                roleUser: "User Roles",
                consultant: "Consultants",
                consultation: "Consultations",
                forum: "Forum",

                profile: "Profile",
                account: "Account",
                settings: "Settings",
                language: "Language",
                logout: "Logout"
            },
            navbar: {
                notifications: "Notifications",
                messages: "Messages"
            },
            profile: {
                saveSuccess: "Profile saved successfully!",
                updateSuccess: "Profile updated successfully.",
                new: "New profile",
                edit: "Edit profile",
                french: "Profile in French",
                arabic: "Profile in Arabic",
                english: "Profile in English",
                loadError: "Error loading the profile.",
                deleteError: "Unable to delete the profile.",
                addSuccess: "Profile added successfully.",
                addError: "Unable to add the profile.",
                deleteSuccess: "Profile deleted successfully."
            },

            specialite: {
                titre: "Specialty",
                saveSuccess: "Specialty saved successfully!",
                new: "New specialty",
                edit: "Edit specialty",
                french: "Specialty in French",
                arabic: "Specialty in Arabic",
                english: "Specialty in English",
                loadError: "Error loading specialty:",
                deleteError: "Unable to delete specialty.",
                addSuccess: "Specialty added.",
                editSuccess: "Specialty updated successfully.",
                addError: "Unable to add specialty.",
                deleteSuccess: "Specialty deleted.",
                list: "List of specialties",
            },
            utilisateur: {

                titre: "User",
                list: "User list",
                listDescription: "Platform user management",

                new: "New user",
                edit: "Edit user",

                fullName: "Full name",
                email: "Email",
                phoneNumber: "Phone number",
                type: "Type",

                typeFelah: "Farmer",
                typeProf: "Professional",
                typeFournisseur: "Supplier",
                unknownType: "Unknown",

                french: "User in French",
                arabic: "User in Arabic",
                english: "User in English",

                noUsers: "No users found.",
                loading: "Loading users...",
                loadingError: "Unable to load users.",
                loadError: "Error loading the user.",

                addSuccess: "User added successfully.",
                saveSuccess: "User saved successfully.",
                editSuccess: "User updated successfully.",
                deleteSuccess: "User deleted successfully.",

                addError: "Unable to add the user.",
                saveError: "Unable to save the user.",
                updateError: "Unable to update the user.",
                deleteError: "Unable to delete the user.",

                page: "Page",
                enabled: "Enabled",

                roles: "Roles",
                role: "Role",

                roleAddSuccess: "Role added successfully.",
                roleRemoveSuccess: "Role removed successfully.",

                roleAddError: "Unable to add the role.",
                roleRemoveError: "Unable to remove the role.",

                rolesLoadError: "Unable to load roles.",
                roleInvalid: "The selected role is invalid.",
            },


            typeActivite: {
                titre: "Activity Type",
                saveSuccess: "Activity type saved successfully!",
                new: "New activity type",
                edit: "Edit activity type",
                french: "Activity type in French",
                arabic: "Activity type in Arabic",
                english: "Activity type in English",
                loadError: "Error loading activity type:",
                deleteError: "Unable to delete activity type.",
                addSuccess: "Activity type added.",
                editSuccess: "Activity type updated successfully.",
                addError: "Unable to add activity type.",
                deleteSuccess: "Activity type deleted.",
                list: "List of activity types",
            },

            commune: {
                titre: "Commune",
                saveSuccess: "Commune saved successfully!",
                new: "New commune",
                edit: "Edit commune",
                french: "Commune in French",
                arabic: "Commune in Arabic",
                english: "Commune in English",
                loadError: "Error loading commune:",
                deleteError: "Unable to delete commune.",
                addSuccess: "Commune added.",
                editSuccess: "Commune updated successfully.",
                addError: "Unable to add commune.",
                deleteSuccess: "Commune deleted.",
                list: "List of communes",
            },

            wilaya: {
                titre: "Wilaya",
                saveSuccess: "Wilaya saved successfully!",
                new: "New wilaya",
                edit: "Edit wilaya",
                french: "Wilaya in French",
                arabic: "Wilaya in Arabic",
                english: "Wilaya in English",
                loadError: "Error loading wilaya:",
                deleteError: "Unable to delete wilaya.",
                addSuccess: "Wilaya added.",
                editSuccess: "Wilaya updated successfully.",
                addError: "Unable to add wilaya.",
                deleteSuccess: "Wilaya deleted.",
                list: "List of wilayas",
            },

            statut: {
                titre: "Status",
                saveSuccess: "Status saved successfully!",
                new: "New status",
                edit: "Edit status",
                french: "Status in French",
                arabic: "Status in Arabic",
                english: "Status in English",
                loadError: "Error loading status:",
                deleteError: "Unable to delete status.",
                addSuccess: "Status added.",
                editSuccess: "Status updated successfully.",
                addError: "Unable to add status.",
                deleteSuccess: "Status deleted.",
                list: "List of statuses",
            },

            activiteProf: {
                titre: "Professional Activity",
                saveSuccess: "Professional activity saved successfully!",
                new: "New professional activity",
                edit: "Edit professional activity",
                french: "Professional activity in French",
                arabic: "Professional activity in Arabic",
                english: "Professional activity in English",
                loadError: "Error loading professional activity:",
                deleteError: "Unable to delete professional activity.",
                addSuccess: "Professional activity added.",
                editSuccess: "Professional activity updated successfully.",
                addError: "Unable to add professional activity.",
                deleteSuccess: "Professional activity deleted.",
                list: "List of professional activities",
            },

            consultant: {
                search: {
                    title: "Find your consultant",
                    subtitle: "Search for an agricultural consultant...",
                    keyword: "Keyword",
                    placeholder: "Search for a consultant, a specialty, or a province...",
                    result: "{{count}} consultant(s) found",
                    select: "Select..."
                },

                types: {
                    agriculture: "Agricultural Consultant",
                    livestock: "Livestock Advisor"
                },

                filters: {

                    title: "Search filters",

                    type: "Consultant type",

                    activities: "Professional activities",
                    specialities: "Specialities",
                    wilaya: "Province",

                    experience: "Minimum experience",

                    available: "Available immediately",

                    choose: "Choose...",
                    allWilayas: "All provinces",
                    all: "All",
                    experience1: "1 year",
                    experience3: "3 years",
                    experience5: "5 years",
                    experience10: "10 years",
                    experience20: "20 years and more"

                },
                card: {
                    agriculturalConsultant: "Agricultural consultant",
                    livestockAdvisor: "Livestock advisor",
                    verified: "Verified",
                    available: "Available",
                    yearsExperience: "{{count}} year(s) of experience",
                    profile: "View profile",
                    consultation: "Consultation",
                    consultant: "Consultant",
                    requester: "Requester"
                }


            },

            consultationRequest: {
                title: "Consultation Requests",
                subtitle: "View and manage consultation requests.",
                pageTitleReceiver: "Consultation requests to process",
                pageTitleSender: "My consultation requests",


                titleReceiver: "Consultation request (s) to process",
                titleSender: "Consultation request (s)",

                noDescription: "No description",
                search: "Search",
                searchPlaceholder: "Consultation subject...",

                noData: "No consultation requests found",
                loading: "Loading requests...",

                consultant: "Consultant",
                requester: "Requester",
                subject: "Subject",
                message: "Message",
                date: "Date",
                createdOn: "Created on {{date}}",
                status: "Status",
                priority: "Priority",
                confirmDelete: "Do you want to delete this request?",
                statusPending: "Pending",
                statusAccepted: "Accepted",
                statusRejected: "Rejected",
                statusInProgress: "In Progress",
                statusClosed: "Closed",

                priorityLow: "Low",
                priorityNormal: "Normal",
                priorityHigh: "High",
                priorityUrgent: "Urgent",
                requestInfo: "Request Information",
                wishToConsult: "I would like to consult",
                consultantSearch: "Consultant Search",

                pageTitleAll: "All consultations",
                pageTitleSender: "Sent consultations",
                pageTitleReceiver: "Received consultations",

            },
            messageComposer: {
                fileTooLarge: "The file \"{{fileName}}\" exceeds the maximum allowed size ({{maxSize}}).",
                invalidExtension: "The \"{{extension}}\" format is not allowed.",
                maxFilesReached: "You cannot attach more than {{maxFiles}} files.",
                subject: "Subject",
                message: "Your message",


                nmessages: "message (s)",
                conversation: "Conversation",
                noContentMessage: "No content.",

            },
            forum: {
                title: "Agricultural Forum",
                home: "Home",
                newTopic: "New Topic",
                editTopic: "Edit topic",
                deleteTopic: "Delete topic",
                objet: "Subject",
                guestMessage: "You can browse the forum freely. To publish a topic or participate in discussions, please log in.",
                searchTopic: "Search for a topic",
                search: "Search",
                reset: "Reset",
                searchPlaceholder: "Title, author, keyword, crops, livestock...",
                topics: "Topics",
                statistics: "Statistics",
                topicDetail: "Topic details",
                openDiscussion: "Start a discussion",

                views: "Views",
                likes: "Likes",
                replies: "Replies",
                open: "Open",
                detail: "Details",

                latestTopics: "Latest Topics",
                noTopics: "No Topics",
                mostViewed: "Most Viewed",
                advice: "Advice",
                noDescription: "No description.",
                solved: "Solved",
                pinned: "Pinned",
                checkExistingQuestion: "Check if your question already exists.",
                details: "Details",
                reply: "Reply",

                backToTopic: "Back to Topic",
                openDiscussionButton: "Open Discussion",
                replyPostedBy: "Reply posted by : ",
                descriptionHelp: "The more detailed your description is, the more relevant the answers will be.",
                pinTopic: "Pin Topic",
                noFileChosen: "No file chosen",
                editTopic: "Edit topic",
                saving: "Saving...",
                topicObjectPlaceholder: "Example: How to irrigate olive trees in summer?",
                topicDescriptionPlaceholder: "Describe your question as precisely as possible...",
                topicObjectRequired: "The topic title is required.",
                topicObjectMinLength: "The topic title must contain at least 5 characters.",
                topicObjectMaxLength: "The topic title must not exceed 100 characters.",
                topicDescriptionRequired: "The topic description is required.",
                topicDescriptionMinLength: "The description must contain at least 10 characters.",
                topicDescriptionMaxLength: "The description must not exceed 3000 characters.",
                invalidFileType: "Only PDF, JPG, JPEG, and PNG files are allowed.",
                noReplies: "No replies",
                beFirstToReply: "Be the first to reply to this discussion.",


                messageOrFileRequired: "Please enter a message or attach at least one file.",


                ForumReply: {
                    subject: "Subject",
                    reply: "Reply",
                    backToSubject: "Back to subject",
                    publishReply: "Publish reply",
                    reset: "Reset",
                    enterYourReply: "Enter your reply…",
                    allowedFormats: "The allowed formats are:",
                    allowedFileTypes: "PDF, JPG, JPEG, PNG, DOC, DOCX, XLS, XLSX.",
                    maximumRecommendedSize: "Recommended maximum size:",
                    perFile: "per file",
                    megabytes: "10 MB",
                    messageOrFileRequired: "Please enter a message or attach at least one file.",
                },
            },

            monProfile: {
                title: "My Profile",

                header: "Profile Information",
                personalInformation: "Personal Information",
                professionalInformation: "Professional Information",
                farmerInformation: "Farmer Information",
                supplierInformation: "Supplier Information",

                summary: "Summary",
                contactInformation: "Contact Information",
                addressInformation: "Address",
                accountInformation: "Account Information",

                photo: "Photo",
                changePhoto: "Change Photo",
                removePhoto: "Remove Photo",
                noPhoto: "No Photo",

                identity: "Identity",
                personalDetails: "Personal Details",
                professionalDetails: "Professional Details",

                consultantInformation: "Consultant Information",
                activityInformation: "Activity Information",

                saveSuccess: "Profile saved successfully.",
                saveError: "An error occurred while saving the profile.",

                loading: "Loading profile...",
                saving: "Saving profile...",
                activiteStartDate: "Activity start date",
                profilePhoto: "Profile photo",

                editPhoto: "Edit photo",
                uploading: "Uploading...",
                choosePhoto: "Choose a photo",
                removePhoto: "Remove photo",
                profileAlt: "Profile",
                personalInformation: "Personal Information",
                fullName: "Full Name",
                email: "Email Address",
                password: "Password",
                phoneNumber: "Phone Number",
                wilaya: "Province",
                commune: "Commune",
                address: "Address",
                userType: "User Type",

                farmer: "🌾 Farmer",
                professional: "👨‍🌾 Professional",
                supplier: "🏪 Supplier",

                professionalInformation: "Professional Information",
                website: "Website",
                status: "Status",
                activityType: "Activity Type",
                professionalActivities: "Professional Activities",
                specialties: "Specialties",

                consultantAgriculture: "Agricultural Consultant",
                livestockAdvisor: "Livestock Advisor",

                password: "Password",
                showPassword: "Show password",
                hidePassword: "Hide password",

                passwordStrength: {
                    veryWeak: "Very weak",
                    weak: "Weak",
                    medium: "Medium",
                    strong: "Strong",
                    veryStrong: "Very strong"
                },



                farmerInformation: "Agricultural Information",
                agriculturalActivities: "Agricultural Activities",
                irrigationSystem: "Irrigation System",
                agriculturalInsurance: "Agricultural Insurance",
                yearsOfExperience: "Years of Experience",
                activityTypes: {
                    agriculture: "Agriculture",
                    livestock: "Livestock",
                    mixed: "Mixed"
                },
            },

            statistics: {
                consultants: "Consultants",
                consultantsDescription: "Agricultural experts and livestock advisors",

                felah: "Fellahs",
                felahDescription: "Registered farmers and livestock breeders",

                agriculture: "Agriculture",
                agricultureDescription: "Fellahs involved in agriculture",

                elevage: "Livestock Farming",
                elevageDescription: "Fellahs involved in livestock farming",

                specialites: "Specialties",
                specialitesDescription: "Agricultural and livestock specialties",

                activities: "Activities",
                activitiesDescription: "Professional activities",

                consultations: "Consultations",
                consultationsDescription: "Registered consultation requests",

                forum: "Forum",
                forumDescription: "Discussion topics",

                loading: "Loading...",
                loadingError: "Unable to load statistics.",
            },

        },

    },

    //---------------------------------------------------------
    // ARABIC
    //---------------------------------------------------------

    ar: {
        translation: {

            connexion: {
                login: "تسجيل الدخول",
                signIn: "تسجيل الدخول",
                loginGoogle: "تسجيل الدخول باستخدام Google",
                loginFacebook: "تسجيل الدخول باستخدام Facebook",
                loginTwitter: "تسجيل الدخول باستخدام Twitter",
                loginEmailPassword: "تسجيل الدخول بالبريد الإلكتروني / كلمة المرور",
                loginPhone: "تسجيل الدخول عبر الهاتف",

                loginSuccess: "تم تسجيل الدخول بنجاح.",
                loginGoogleSuccess: "تم تسجيل الدخول باستخدام Google بنجاح.",
                loginFacebookSuccess: "تم تسجيل الدخول باستخدام Facebook بنجاح.",
                loginTwitterSuccess: "تم تسجيل الدخول باستخدام Twitter بنجاح.",
                loginEmailPasswordSuccess: "تم تسجيل الدخول بالبريد الإلكتروني وكلمة المرور بنجاح.",
                loginPhoneSuccess: "تم تسجيل الدخول عبر الهاتف بنجاح.",

                loginError: "تعذر تسجيل الدخول.",
                loginGoogleError: "تعذر تسجيل الدخول باستخدام Google.",
                loginFacebookError: "تعذر تسجيل الدخول باستخدام Facebook.",
                loginTwitterError: "تعذر تسجيل الدخول باستخدام Twitter.",
                loginEmailPasswordError: "تعذر تسجيل الدخول بالبريد الإلكتروني وكلمة المرور.",
                loginPhoneError: "تعذر تسجيل الدخول عبر الهاتف.",

                loginInProgress: "جارٍ تسجيل الدخول…",

                forgotPassword: "هل نسيت كلمة المرور؟",
                orContinueWith: "أو المتابعة باستخدام",
                continueWithGoogle: "المتابعة باستخدام Google",

                noAccount: "ليس لديك حساب بعد؟",
                createAccount: "إنشاء حساب",

                emailNotVerified: "لم يتم التحقق من عنوان بريدك الإلكتروني بعد. يُرجى التحقق من صندوق بريدك.",
                userNotFound: "المستخدم غير موجود.",
                incorrectPassword: "كلمة المرور غير صحيحة.",
                invalidEmailOrPassword: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
                invalidEmail: "عنوان البريد الإلكتروني غير صالح.",

                signUp: "إنشاء حساب",
                alreadyHaveAccount: "هل لديك حساب بالفعل؟",
                emailAlreadyInUse: "عنوان البريد الإلكتروني هذا مستخدم بالفعل.",
                passwordMinLength: "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل.",
                firebaseConnectionError: "تعذر الاتصال بـ Firebase.",
                unknownError: "خطأ غير معروف.",

            },
            common: {
                code: "الرمز",
                id: "المعرّف",
                and: "و",
                or: "أو",
                yes: "نعم",
                no: "لا",
                select: "اختر...",
                noOptions: "لا توجد خيارات متاحة",
                loading: "جارٍ التحميل...",
                attachments: "المرفقات",
                attachment: "المرفق",
                chooseFile: "اختر ملفًا",
                noAttachment: "لا توجد مرفقات",
                allowedFormats: "الصيغ المسموح بها: ",
                maxSize: "الحد الأقصى للحجم: ",
                deleteError: "تعذر الحذف.",
                french: " باللغة الفرنسية",
                english: " باللغة الإنجليزية",
                arabic: " باللغة العربية",
                actions: "الإجراءات",
                rows: "الصفوف",
                welcome: "مرحباً بكم في FelahLink",
                welcomeDescription: "ربط الفلاحين بسرعة بالمستشارين الزراعيين والأطباء البيطريين والخبراء في القطاع الفلاحي الأقرب إليهم.",
                loadListsError: "تعذر تحميل القوائم.",
                contact: "اتصل بنا",
                navigation: "التنقل",

                felahLink: "FelahLink",
                location: "الجزائر - الجزائر",
                about: "حول المنصة",
                version: "الإصدار v1.0",

                platformDescription:
                    "منصة وطنية لربط الفلاحين بالمستشارين الزراعيين والأطباء البيطريين والخبراء في القطاع الفلاحي.",

                services: "الخدمات",
                consultantSearch: "البحث عن المستشارين",
                onlineConsultation: "الاستشارة عبر الإنترنت",
                farmManagement: "تسيير المستغلّات الفلاحية",
                technicalAssistance: "المساعدة التقنية",
                deleteSuccess: "تم حذف السجل بنجاح!",
            },

            validation: {
                requiredMessage: "الرسالة إلزامية.",
                consultationObjectRequired: "موضوع الاستشارة مطلوب.",
                receiverRequired: "يرجى اختيار مستشار.",
                activityTypeRequired: "نوع النشاط إجباري",
                activityProfRequired: "النشاط باللغة الفرنسية إجباري",
                correctErrors: "يرجى تصحيح الأخطاء",
                updateError: "حدث خطأ أثناء التحديث.",
                validationErrors: "أخطاء التحقق",
            },

            button: {
                search: "بحث",
                reset: "إعادة التعيين",
                save: "حفظ",
                cancel: "إلغاء",
                back: "رجوع",
                profile: "عرض الملف الشخصي",
                consultation: "استشارة",
                available: "متاح",
                verified: "موثق",
                detail: "عرض التفاصيل",
                actions: "الإجراءات",
                details: "التفاصيل",
                add: "إضافة",
                view: "عرض",
                edit: "تعديل",
                delete: "حذف",

                create: "طلب جديد",
                send: "إرسال",
                reply: "الرد",
                close: "إغلاق",
                reopen: "إعادة فتح",
                close: "إغلاق",
                deleteConfirmationTitle: "تأكيد الحذف",
                deleteConfirmationMessage: "هل أنت متأكد من رغبتك في حذف هذا السجل؟",
                download: "تحميل",

            },

            menu: {
                mainMenu: "القائمة الرئيسية",
                dashboard: "لوحة التحكم",
                adminPanel: "لوحة الإدارة",

                home: "الرئيسية",

                file: "البيانات الأساسية",

                activityProf: "النشاط المهني",
                activityType: "نوع النشاط",
                consultantStatus: "حالة المستشار",
                speciality: "التخصص",
                wilaya: "الولاية",
                commune: "البلدية",

                user: "المستخدمون",
                roleUser: "أدوار المستخدمين",
                consultant: "المستشارون",
                consultation: "الاستشارات",
                forum: "المنتدى",

                profile: "الملف الشخصي",
                account: "الحساب",
                settings: "الإعدادات",
                language: "اللغة",
                logout: "الخروج"
            },
            navbar: {
                notifications: "الإشعارات",
                messages: "الرسائل"
            },
            profile: {
                saveSuccess: "تم حفظ الملف الشخصي بنجاح!",
                updateSuccess: "تم تحديث الملف الشخصي بنجاح.",
                new: "ملف شخصي جديد",
                edit: "تعديل الملف الشخصي",
                french: "الملف الشخصي باللغة الفرنسية",
                arabic: "الملف الشخصي باللغة العربية",
                english: "الملف الشخصي باللغة الإنجليزية",
                loadError: "حدث خطأ أثناء تحميل الملف الشخصي.",
                deleteError: "تعذر حذف الملف الشخصي.",
                addSuccess: "تمت إضافة الملف الشخصي بنجاح.",
                addError: "تعذر إضافة الملف الشخصي.",
                deleteSuccess: "تم حذف الملف الشخصي بنجاح."
            },
            specialite: {
                titre: "التخصص",
                saveSuccess: "تم حفظ التخصص بنجاح!",
                new: "تخصص جديد",
                edit: "تعديل التخصص",
                french: "التخصص باللغة الفرنسية",
                arabic: "التخصص باللغة العربية",
                english: "التخصص باللغة الإنجليزية",
                loadError: "حدث خطأ أثناء تحميل التخصص:",
                deleteError: "تعذر حذف التخصص.",
                addSuccess: "تمت إضافة التخصص.",
                editSuccess: "تم تعديل التخصص بنجاح.",
                addError: "تعذر إضافة التخصص.",
                deleteSuccess: "تم حذف التخصص.",
                list: "قائمة التخصصات",
            },

            utilisateur: {

                titre: "المستخدم",
                list: "قائمة المستخدمين",
                listDescription: "إدارة مستخدمي المنصة",

                new: "مستخدم جديد",
                edit: "تعديل المستخدم",

                fullName: "الاسم الكامل",
                email: "البريد الإلكتروني",
                phoneNumber: "رقم الهاتف",
                type: "النوع",

                typeFelah: "فلاح",
                typeProf: "مهني",
                typeFournisseur: "مورد",
                unknownType: "غير معروف",

                french: "المستخدم باللغة الفرنسية",
                arabic: "المستخدم باللغة العربية",
                english: "المستخدم باللغة الإنجليزية",

                noUsers: "لم يتم العثور على أي مستخدم.",
                loading: "جارٍ تحميل المستخدمين...",
                loadingError: "تعذر تحميل المستخدمين.",
                loadError: "حدث خطأ أثناء تحميل المستخدم.",

                addSuccess: "تمت إضافة المستخدم بنجاح.",
                saveSuccess: "تم تسجيل المستخدم بنجاح.",
                editSuccess: "تم تعديل المستخدم بنجاح.",
                deleteSuccess: "تم حذف المستخدم بنجاح.",

                addError: "تعذر إضافة المستخدم.",
                saveError: "تعذر تسجيل المستخدم.",
                updateError: "تعذر تعديل المستخدم.",
                deleteError: "تعذر حذف المستخدم.",

                page: "الصفحة",
                enabled: "مفعّل",
                roles: "الأدوار",
                role: "الدور",

                roleAddSuccess: "تمت إضافة الدور بنجاح.",
                roleRemoveSuccess: "تم حذف الدور بنجاح.",

                roleAddError: "تعذر إضافة الدور.",
                roleRemoveError: "تعذر حذف الدور.",

                rolesLoadError: "تعذر تحميل الأدوار.",
                roleInvalid: "الدور المحدد غير صالح.",
            },

            typeActivite: {
                titre: "نوع النشاط",
                saveSuccess: "تم حفظ نوع النشاط بنجاح!",
                new: "نوع نشاط جديد",
                edit: "تعديل نوع النشاط",
                french: "نوع النشاط باللغة الفرنسية",
                arabic: "نوع النشاط باللغة العربية",
                english: "نوع النشاط باللغة الإنجليزية",
                loadError: "حدث خطأ أثناء تحميل نوع النشاط:",
                deleteError: "تعذر حذف نوع النشاط.",
                addSuccess: "تمت إضافة نوع النشاط.",
                editSuccess: "تم تعديل نوع النشاط بنجاح.",
                addError: "تعذر إضافة نوع النشاط.",
                deleteSuccess: "تم حذف نوع النشاط.",
                list: "قائمة أنواع الأنشطة",
            },

            commune: {
                titre: "البلدية",
                saveSuccess: "تم حفظ البلدية بنجاح!",
                new: "بلدية جديدة",
                edit: "تعديل البلدية",
                french: "البلدية باللغة الفرنسية",
                arabic: "البلدية باللغة العربية",
                english: "البلدية باللغة الإنجليزية",
                loadError: "حدث خطأ أثناء تحميل البلدية:",
                deleteError: "تعذر حذف البلدية.",
                addSuccess: "تمت إضافة البلدية.",
                editSuccess: "تم تعديل البلدية بنجاح.",
                addError: "تعذر إضافة البلدية.",
                deleteSuccess: "تم حذف البلدية.",
                list: "قائمة البلديات",
            },

            wilaya: {
                titre: "الولاية",
                saveSuccess: "تم حفظ الولاية بنجاح!",
                new: "ولاية جديدة",
                edit: "تعديل الولاية",
                french: "الولاية باللغة الفرنسية",
                arabic: "الولاية باللغة العربية",
                english: "الولاية باللغة الإنجليزية",
                loadError: "حدث خطأ أثناء تحميل الولاية:",
                deleteError: "تعذر حذف الولاية.",
                addSuccess: "تمت إضافة الولاية.",
                editSuccess: "تم تعديل الولاية بنجاح.",
                addError: "تعذر إضافة الولاية.",
                deleteSuccess: "تم حذف الولاية.",
                list: "قائمة الولايات",
            },

            statut: {
                titre: "الحالة",
                saveSuccess: "تم حفظ الحالة بنجاح!",
                new: "حالة جديدة",
                edit: "تعديل الحالة",
                french: "الحالة باللغة الفرنسية",
                arabic: "الحالة باللغة العربية",
                english: "الحالة باللغة الإنجليزية",
                loadError: "حدث خطأ أثناء تحميل الحالة:",
                deleteError: "تعذر حذف الحالة.",
                addSuccess: "تمت إضافة الحالة.",
                editSuccess: "تم تعديل الحالة بنجاح.",
                addError: "تعذر إضافة الحالة.",
                deleteSuccess: "تم حذف الحالة.",
                list: "قائمة الحالات",
            },

            activiteProf: {
                titre: "النشاط المهني",
                saveSuccess: "تم حفظ النشاط المهني بنجاح!",
                new: "نشاط مهني جديد",
                edit: "تعديل النشاط المهني",
                french: "النشاط المهني باللغة الفرنسية",
                arabic: "النشاط المهني باللغة العربية",
                english: "النشاط المهني باللغة الإنجليزية",
                loadError: "حدث خطأ أثناء تحميل النشاط المهني:",
                deleteError: "تعذر حذف النشاط المهني.",
                addSuccess: "تمت إضافة النشاط المهني.",
                editSuccess: "تم تعديل النشاط المهني بنجاح.",
                addError: "تعذر إضافة النشاط المهني.",
                deleteSuccess: "تم حذف النشاط المهني.",
                list: "قائمة الأنشطة المهنية",
            },
            consultant: {
                search: {
                    title: "ابحث عن المستشار المناسب",
                    subtitle: "ابحث عن مستشار فلاحي أو طبيب بيطري أو مختص بالقرب منك.",
                    keyword: "كلمة البحث",
                    placeholder: "ابحث عن مستشار أو تخصص أو ولاية...",
                    result: "تم العثور على {{count}} مستشار",
                    select: "اختر..."

                },

                types: {
                    agriculture: "مستشار فلاحي",
                    livestock: "مستشار تربية المواشي"
                },

                filters: {

                    title: "معايير البحث",
                    type: "نوع المستشار",
                    activities: "الأنشطة المهنية",
                    specialities: "التخصصات",
                    wilaya: "الولاية",
                    experience: "الخبرة الدنيا",
                    available: "متوفر حالياً",
                    choose: "اختر...",
                    allWilayas: "كل الولايات",
                    all: "الكل",
                    experience1: "سنة واحدة",
                    experience3: "3 سنوات",
                    experience5: "5 سنوات",
                    experience10: "10 سنوات",
                    experience20: "20 سنة فأكثر"

                },

                card: {

                    agriculturalConsultant: "مستشار فلاحي",
                    livestockAdvisor: "مستشار تربية المواشي",
                    verified: "موثق",
                    available: "متوفر",
                    yearsExperience: "{{count}} سنة خبرة",
                    profile: "عرض الملف",
                    consultation: "استشارة",
                    consultant: "المستشار",

                    requester: "طالب الاستشارة"

                }
            },

            consultationRequest: {

                title: " الاستشارة ",
                subtitle: "عرض وإدارة طلبات الاستشارة.",

                pageTitleReceiver: "طلبات الاستشارة الواردة",
                pageTitleSender: "طلبات الاستشارة الخاصة بي",

                titleReceiver: "طلبات الاستشارة الواردة",
                titleSender: "طلبات الاستشارة",



                search: "بحث",
                searchPlaceholder: "موضوع الاستشارة...",

                noData: "لا توجد طلبات استشارة",
                loading: "جاري تحميل الطلبات...",
                noDescription: "لا يوجد وصف",
                consultant: "المستشار",
                requester: "صاحب الطلب",
                subject: "الموضوع",
                message: "الرسالة",
                date: "التاريخ",
                createdOn: "تم الإنشاء بتاريخ {{date}}",
                status: "الحالة",
                priority: "الأولوية",

                confirmDelete: "هل تريد حذف هذا الطلب؟",

                statusPending: "قيد الانتظار",
                statusAccepted: "مقبول",
                statusRejected: "مرفوض",
                statusInProgress: "قيد المعالجة",
                statusClosed: "مغلق",

                priorityLow: "منخفضة",
                priorityNormal: "عادية",
                priorityHigh: "مرتفعة",
                priorityUrgent: "عاجلة",
                requestInfo: "معلومات الطلب",
                wishToConsult: "أرغب في الاستشارة",
                consultantSearch: "البحث عن المستشار",
                pageTitleAll: "جميع الاستشارات",
                pageTitleSender: "الاستشارات المرسلة",
                pageTitleReceiver: "الاستشارات المستلمة",
            },
            messageComposer: {
                fileTooLarge: "يتجاوز الملف \"{{fileName}}\" الحجم الأقصى المسموح به ({{maxSize}}).",
                invalidExtension: "امتداد الملف \"{{extension}}\" غير مسموح به.",
                maxFilesReached: "لا يمكنك إرفاق أكثر من {{maxFiles}} ملفات.",
                subject: "الموضوع",
                message: "رسالتك",
                nmessage: "رسائل",
                conversation: "المحادثة",
                noContentMessage: "لا يوجد محتوى.",
            },
            forum: {
                title: "المنتدى الفلاحي",
                home: "الرئيسية",
                newTopic: "موضوع جديد",
                editTopic: "تعديل الموضوع",
                deleteTopic: "حذف الموضوع",
                objet: "الموضوع",
                guestMessage:
                    "يمكنك تصفح المنتدى بحرية. لنشر موضوع أو المشاركة في المناقشات، يرجى تسجيل الدخول.",

                searchTopic: "البحث عن موضوع",
                search: "بحث",
                reset: "إعادة تعيين",
                searchPlaceholder:
                    "العنوان، الكاتب، الكلمة المفتاحية، المحاصيل، تربية المواشي...",

                topics: "المواضيع",
                statistics: "الإحصائيات",
                topicDetail: "تفاصيل الموضوع",
                openDiscussion: "فتح نقاش",

                views: "المشاهدات",
                likes: "الإعجابات",
                replies: "الردود",
                open: "فتح",
                detail: "التفاصيل",
                latestTopics: "أحدث المواضيع",
                noTopics: "لا توجد مواضيع",
                mostViewed: "الأكثر مشاهدة",
                advice: "نصائح",
                noDescription: "لا يوجد وصف.",
                solved: "تم الحل",
                pinned: "مثبت",
                checkExistingQuestion: "تحقق مما إذا كان سؤالك موجودًا بالفعل.",
                details: "التفاصيل",
                reply: "الرد",


                backToTopic: "العودة إلى الموضوع",
                openDiscussionButton: "فتح النقاش",
                replyPostedBy: "  تم نشر الرد بواسطة :  ",
                description: "وصف الموضوع",

                descriptionHelp: "كلما كان وصفك أكثر تفصيلاً، كانت الإجابات أكثر صلة.",
                pinTopic: "تثبيت الموضوع",
                noFileChosen: "لم يتم اختيار أي ملف",
                editTopic: "تعديل الموضوع",
                saving: "جارٍ الحفظ...",
                topicObjectPlaceholder: "مثال: كيف يتم ري أشجار الزيتون في فصل الصيف؟",
                topicDescriptionPlaceholder: "صف سؤالك بأكبر قدر ممكن من الدقة...",
                topicObjectRequired: "عنوان الموضوع إلزامي.",
                topicObjectMinLength: "يجب أن يحتوي عنوان الموضوع على 5 أحرف على الأقل.",
                topicObjectMaxLength: "يجب ألا يتجاوز عنوان الموضوع 100 حرف.",
                topicDescriptionRequired: "وصف الموضوع إلزامي.",
                topicDescriptionMinLength: "يجب أن يحتوي الوصف على 10 أحرف على الأقل.",
                topicDescriptionMaxLength: "يجب ألا يتجاوز الوصف 3000 حرف.",
                invalidFileType: "يُسمح فقط بملفات PDF وJPG وJPEG وPNG.",
                noReplies: "لا توجد ردود",
                beFirstToReply: "كن أول من يرد على هذه المناقشة.",


                messageOrFileRequired: "يرجى إدخال رسالة أو إرفاق ملف واحد على الأقل.",
                ForumReply: {
                    subject: "الموضوع",
                    reply: "الرد",
                    backToSubject: "العودة إلى الموضوع",
                    publishReply: "نشر الرد",
                    reset: "إعادة تعيين",
                    enterYourReply: "أدخل ردك…",
                    allowedFormats: "الصيغ المسموح بها هي:",
                    allowedFileTypes: "PDF, JPG, JPEG, PNG, DOC, DOCX, XLS, XLSX.",
                    maximumRecommendedSize: "الحد الأقصى الموصى به للحجم:",
                    perFile: "لكل ملف",
                    megabytes: "10 ميغابايت",
                    messageOrFileRequired: "يرجى إدخال رسالة أو إرفاق ملف واحد على الأقل.",
                },
            },
            monProfile: {
                title: "ملفي الشخصي",
                header: "معلومات الملف الشخصي",
                personalInformation: "المعلومات الشخصية",
                professionalInformation: "المعلومات المهنية",
                farmerInformation: "معلومات الفلاح",
                supplierInformation: "معلومات المورد",

                summary: "ملخص",
                contactInformation: "معلومات الاتصال",
                addressInformation: "العنوان",
                accountInformation: "معلومات الحساب",

                photo: "الصورة",
                changePhoto: "تغيير الصورة",
                removePhoto: "حذف الصورة",
                noPhoto: "لا توجد صورة",

                identity: "الهوية",
                personalDetails: "البيانات الشخصية",
                professionalDetails: "البيانات المهنية",

                consultantInformation: "معلومات المستشار",
                activityInformation: "معلومات النشاط",

                saveSuccess: "تم حفظ الملف الشخصي بنجاح.",
                saveError: "حدث خطأ أثناء حفظ الملف الشخصي.",

                loading: "جارٍ تحميل الملف الشخصي...",
                saving: "جارٍ حفظ الملف الشخصي...",
                activiteStartDate: "تاريخ بداية النشاط",
                profilePhoto: "الصورة الشخصية",
                editPhoto: "تعديل الصورة",
                uploading: "جارٍ الرفع...",
                choosePhoto: "اختر صورة",
                removePhoto: "حذف الصورة",
                profileAlt: "الملف الشخصي",
                personalInformation: "المعلومات الشخصية",
                fullName: "الاسم الكامل",
                email: "البريد الإلكتروني",
                password: "كلمة المرور",
                phoneNumber: "رقم الهاتف",
                wilaya: "الولاية",
                commune: "البلدية",
                address: "العنوان",
                userType: "نوع المستخدم",

                farmer: "🌾 فلاح",
                professional: "👨‍🌾 مهني",
                supplier: "🏪 مورد",

                professionalInformation: "المعلومات المهنية",
                website: "الموقع الإلكتروني",
                status: "الحالة",
                activityType: "نوع النشاط",
                professionalActivities: "الأنشطة المهنية",
                specialties: "التخصصات",

                consultantAgriculture: "مستشار في الزراعة",
                livestockAdvisor: "مستشار / مستشارة في تربية المواشي",

                password: "كلمة المرور",
                showPassword: "إظهار كلمة المرور",
                hidePassword: "إخفاء كلمة المرور",

                passwordStrength: {
                    veryWeak: "ضعيف جدًا",
                    weak: "ضعيف",
                    medium: "متوسط",
                    strong: "قوي",
                    veryStrong: "قوي جدًا"
                },

                farmerInformation: "المعلومات الزراعية",
                agriculturalActivities: "الأنشطة الزراعية",
                irrigationSystem: "نظام الري",
                agriculturalInsurance: "التأمين الزراعي",
                yearsOfExperience: "سنوات الخبرة",

                activityTypes: {
                    agriculture: "الزراعة",
                    livestock: "تربية المواشي",
                    mixed: "مختلط"
                },
            },

            statistics: {
                consultants: "المستشارون",
                consultantsDescription: "الخبراء الزراعيون ومستشارو تربية المواشي",

                felah: "الفلاحون",
                felahDescription: "الفلاحون ومربو المواشي المسجلون",

                agriculture: "الزراعة",
                agricultureDescription: "الفلاحون في مجال الزراعة",

                elevage: "تربية المواشي",
                elevageDescription: "الفلاحون في مجال تربية المواشي",

                specialites: "التخصصات",
                specialitesDescription: "التخصصات الزراعية وتربية المواشي",

                activities: "الأنشطة",
                activitiesDescription: "الأنشطة المهنية",

                consultations: "الاستشارات",
                consultationsDescription: "طلبات الاستشارة المسجلة",

                forum: "المنتدى",
                forumDescription: "مواضيع النقاش",

                loading: "جارٍ التحميل...",
                loadingError: "تعذر تحميل الإحصائيات.",
            },

        },


    },


};

i18n
    .use(initReactI18next)
    .init({

        resources,
        lng: "fr",
        fallbackLng: "fr",
        interpolation: {
            escapeValue: false
        }

    });

export default i18n;